/// <amd-module name="Wit/Portal/Redux/WorkItemPortalSelectors" />
import { IWorkItemPortalAwareState, IPortalWorkItem } from "./WorkItemPortalContracts";

export function getNextWorkItem(state: IWorkItemPortalAwareState): IPortalWorkItem | undefined {
    const queue = state.workItemPortalState && state.workItemPortalState.workItemQueue;
    return queue && queue.length > 0 ? queue[queue.length - 1] : undefined;
}
